import { render, staticRenderFns } from "./DictationIndex.vue?vue&type=template&id=2a439ca2&scoped=true&"
import script from "./DictationIndex.vue?vue&type=script&lang=js&"
export * from "./DictationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a439ca2",
  null
  
)

export default component.exports